import {
  CheckMetadata,
  createRiskLevelMetadataItem,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdFabricationDetection } from 'dashboard/models/check';

export const computeIdFabricationDetectionMetadata = (
  check: IdFabricationDetection,
): CheckMetadata => {
  const metadata = [];

  const risks = check?.metadata?.risks;
  const portraitFabricationRiskData = createRiskLevelMetadataItem(
    'Fabricated Version Risk',
    risks,
    'fabricated_id_version',
  );

  if (portraitFabricationRiskData) {
    metadata.push(portraitFabricationRiskData);
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
